<template>
  <el-row>
    <!-- 大图 style="margin-left:25%;margin-top:-33%" -->
    <el-row>
      <BigImg v-show="showImg" @click="viewImg()" :imgSrc="imgSrc" style="z-index: 1001;"></BigImg>
    </el-row>
    <!-- 选宿舍 -->
    <el-row v-show="chooseDormVisible">
      <el-row style="background-color: #fff;padding-top: 20px">
        <el-row style="background-color: #fff; text-align: center;">
          <el-form :model="dormSetForm" ref="dormSetForm" label-width="90px" style="width: 50%;background-color: #fff;margin:auto">
            <el-row>
              <img class="banner-img" :src="effectDrawing" @click="clickImg($event)" style="width: 50%; height: 150px; float: left;">
              <img class="banner-img" :src="bedDiagram" @click="clickImg($event)" style="width: 50%; height: 150px; float: right;">
            </el-row>
            <el-form-item label="收费标准">
              <span >{{ dormSetForm.price }}</span>
            </el-form-item>
            <el-form-item label="规格">
              <span >{{ dormSetForm.dormStandard }}</span>
            </el-form-item>
            <el-form-item label="宿舍配置">
              <span >{{ dormSetForm.roomSet }}</span>
            </el-form-item>
            <el-form-item label="公共配置">
              <span >{{ dormSetForm.pubAreaSet }}</span>
            </el-form-item>
            <el-form-item label="所在区域">
              <span >{{ dormSetForm.region }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span >{{ dormSetForm.remark }}</span>
            </el-form-item>
          </el-form>
        </el-row>
      </el-row>
      <el-row style="background-color: #fff;text-align: center;">
        <el-form :inline="global.editInline" :model="dormChooseForm" ref="dormChooseForm" :label-width="formLabelWidth" style="width: 50%;background-color: #fff;margin:auto">
          <el-form-item label="公寓" class="form-item">
            <!-- 下拉框 -->
            <el-select v-model="dormChooseForm['flatsName']" placeholder="== 请选择 ==" :disabled="getDisableEdit('flatsName', 'form')" 
              :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-option v-for="option in modeSelector('Flats')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宿舍类型" class="form-item">
            <!-- 下拉框 -->
            <el-select v-model="dormChooseForm['dormSet']" placeholder="== 请选择 ==" :disabled="getDisableEdit('dormSet', 'form')" 
              :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-option v-for="option in modeSelector('Dorm_Set')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宿舍" class="form-item">
            <!-- 下拉框 -->
            <el-select v-model="dormChooseForm['roomNo']" placeholder="== 请选择 ==" :disabled="getDisableEdit('roomNo', 'form')" 
              :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-option v-for="option in modeSelector('Room')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="床位" class="form-item">
            <!-- 下拉框 -->
            <el-select v-model="dormChooseForm['bedNo']" placeholder="== 请选择 ==" :disabled="getDisableEdit('bedNo', 'form')" 
              :class="Ginkgo.getEditItemClass(global.editInline)">
              <el-option v-for="option in modeSelector('Bed')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span class="deg-title">四人间床位  总计: {{fourBedSum}}  剩余：{{fourBedRmi}}  </span>
          </el-form-item>
          <el-form-item>
            <span class="deg-title">六人间床位  总计: {{sixBedSum}}  剩余：{{sixBedRmi}}  </span>
          </el-form-item>
          <el-form-item>
            <span class="deg-title">八人间床位  总计: {{eightBedSum}}  剩余：{{eightBedRmi}}  </span>
          </el-form-item>
        </el-form>
        <el-row style="text-align:center;padding:10px 0">
          <el-button type="success" @click="addBed()" :disabled="disabledBtn">确定</el-button>
        </el-row>
      </el-row>
    </el-row>
    <!-- 已选选宿舍展示 -->
    <el-row v-show="chooseDormSelectedVisible">
      <el-row style="background-color: #fff;padding-top: 20px">
        <el-row style="background-color: #fff; text-align: center;">
          <el-form :model="dormSelectedSetForm" ref="dormSelectedSetForm" :label-width="formLabelWidth" style="width: 50%;background-color: #fff;margin:auto">
            <el-row>
              <img class="banner-img" :src="effectDrawing" style="width: 50%; height: 150px; float: left;">
              <img class="banner-img" :src="bedDiagram"  style="width: 50%; height: 150px; float: right;">
            </el-row>
            <el-form-item class="form-item"></el-form-item>
            <el-form-item label="公寓：" class="form-item">
              <span >{{ dormSelectedSetForm.flatsName }}</span>
            </el-form-item>
            <el-form-item label="宿舍类型：" class="form-item">
              <span >{{ dormSelectedSetForm.dormSet }}</span>
            </el-form-item>
            <el-form-item label="宿舍：" class="form-item">
              <span >{{ dormSelectedSetForm.roomNo }}</span>
            </el-form-item>
            <el-form-item label="床位：" class="form-item">
              <span >{{ dormSelectedSetForm.bedNo }}</span>
            </el-form-item>
            <el-form-item label="收费标准：" class="form-item">
              <span >{{ dormSelectedSetForm.price }}</span>
            </el-form-item>
            <el-form-item label="宿舍配置：" class="form-item">
              <span >{{ dormSelectedSetForm.roomSet }}</span>
            </el-form-item>
            <el-form-item label="公共配置：" class="form-item">
              <span >{{ dormSelectedSetForm.pubAreaSet }}</span>
            </el-form-item>
            <el-form-item label="所在区域：" class="form-item">
              <span >{{ dormSelectedSetForm.region }}</span>
            </el-form-item>
          </el-form>
          <el-row style="text-align:center;padding:10px 0">
            <el-button type="success" @click="toHome()">去首页</el-button>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
export default {
  name: 'DormOld', // ?
  data: function () {
    return {
      // 选宿舍窗体
      dormList: [], // 当前可选宿舍列表
      chosenDorm: {}, // 当前选择的宿舍列表
      dormSetForm: {}, // 宿舍类型配置信息
      dormSelectedSetForm: {}, // 已选宿舍配置信息
      dormSetList: [], // 宿舍类型下拉框
      dormChooseForm: { // 选宿舍
        dormSet: '',
        flatsName: '',
        roomNo: '',
        bedNo: ''
      },
      route: [],
      curStudent: {},
      fourBedSum: '0', // 四人间总数
      fourBedRmi: '0', // 四人间剩余
      sixBedSum: '0', // 六人间总数
      sixBedRmi: '0', // 六人间剩余
      eightBedSum: '0', // 八人间剩余
      eightBedRmi: '0', // 八人间剩余
      // 查询窗体
      uiSetItemList: [], // 原始
      uiSetList: [],
      modeSelectList: [], // 字典
      chooseDormVisible: false, // 宿舍信息选择
      chooseDormSelectedVisible: false, // 宿舍已选信息展示
      formLabelWidth: '90px',
      // 公寓相关图片
      effectDrawing: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/4rj.jpg',
      bedDiagram: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/10001.png',

      showImg: false, // 获取当前图片地址
      imgSrc: '',

      waitTimeStart: '', // 初始化选宿舍时间
      disabledBtn: false // 确定禁用按钮
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      this.curStudent = this.global.curStudent
      console.log('进来了', this.curStudent)
      this.getMode()
      this.getViXFDormBed()
      this.initThis()
      this.initWaitTime()
    } else {
      this.getMode()
      this.initThis()
      this.initWaitTime()
    }
  },
  watch: {
    'dormChooseForm.flatsName': 'handleFlatsChange',
    'dormChooseForm.dormSet': 'handleDormSetChange',
    'dormChooseForm.roomNo': 'handleRoomChange'
  },
  methods: {
    getDorm: function () {
      var self = this
      return self.axios.post('/college/getViXFDormOldForChoose', {
        schoolYear: self.curStudent.schoolYear,
        deptName: self.curStudent.deptName,
        sex: self.curStudent.sex
      })
    },
    // 初始化数据字典
    getMode: function () {
      this.modeSelectList = this.global.modeList
    },
    initWaitTime: function() {
      this.waitTimeStart = new Date().getTime()
    },
    getViXFDormBed: function() {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.post('/college/getViXFDormOldBed', {
          schoolYear: self.curStudent.schoolYear,
          keyInfo: this.curStudent.studyNo
        }).then(function(response) {
          if (response.data.result.success) {
            if (response.data.viXFDormList.length > 0 || response.data.viXFDormSetList.length > 0) {
              self.setVisible('01')
              self.dormSelectedSetForm.flatsName = response.data.viXFDormSetList[0].flatsName
              self.dormSelectedSetForm.dormSet = response.data.viXFDormSetList[0].dormStandard + response.data.viXFDormSetList[0].direction
              self.dormSelectedSetForm.roomNo = response.data.viXFDormList[0].roomNo
              self.dormSelectedSetForm.bedNo = response.data.viXFDormList[0].bedNo
              self.dormSelectedSetForm.price = response.data.viXFDormSetList[0].price
              self.dormSelectedSetForm.roomSet = response.data.viXFDormSetList[0].roomSet
              self.dormSelectedSetForm.pubAreaSet = response.data.viXFDormSetList[0].pubAreaSet
              self.dormSelectedSetForm.region = response.data.viXFDormSetList[0].region
              self.effectDrawing = self.global.staticUploadAddr + response.data.viXFDormSetList[0].effectDrawing
              self.bedDiagram = self.global.staticUploadAddr + response.data.viXFDormSetList[0].bedDiagram
            } else {
              self.setVisible('00')
              self.dormChooseForm.roomNo = ''
              self.dormChooseForm.bedNo = ''
            }
          }
        })
      } else {
        this.dormSelectedSetForm.flatsName = '西区学生公寓十号楼'
        this.dormSelectedSetForm.dormSet = '四人间A朝南'
        this.dormSelectedSetForm.roomNo = '东101'
        this.dormSelectedSetForm.bedNo = '1'
        this.dormSelectedSetForm.price = '2000'
        this.dormSelectedSetForm.roomSet = 'wifi，洗手间'
        this.dormSelectedSetForm.pubAreaSet = '洗衣机、健身房'
        this.dormSelectedSetForm.region = '西区66'
        this.setVisible('01')
      }
    },
    // 加载宿舍信息
    initThis: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.post('/college/getViXFDormOldBedCount', {
          schoolYear: self.curStudent.schoolYear,
          deptName: self.curStudent.deptName,
          sex: self.curStudent.sex
        }).then(function (response) {
          console.log(response)
          if (response.data.result.success === true) {
            self.sixBedSum = response.data.viXFDormList[0].sixBedSum
            self.fourBedSum = response.data.viXFDormList[0].fourBedSum
            self.eightBedSum = response.data.viXFDormList[0].eightBedSum
            self.sixBedRmi = response.data.viXFDormList[0].sixBedRmi
            self.fourBedRmi = response.data.viXFDormList[0].fourBedRmi
            self.eightBedRmi = response.data.viXFDormList[0].eightBedRmi
          }
        })
        self.axios.all([self.getDorm()]
        ).then(this.axios.spread(function (dorm) {
          if (dorm.data.result.success === true) {
            self.dormList = dorm.data.viXFDormList
            self.modeSelectList = self.modeSelectList.concat(dorm.data.modeList)
            self.dormSetList = dorm.data.viXFDormSetList
            if (dorm.data.viXFDormList === null || dorm.data.modeList === null || dorm.data.viXFDormSetList === null) {
              this.disabledBtn = true
              this.$alert('无可选宿舍')
            }
            // 初始化宿舍选择
            if (self.modeSelector('Flats').length > 0) {
              // 公寓选择初始化成第一个公寓
              self.dormChooseForm.flatsName = self.modeSelector('Flats')[0].modeId
              // 宿舍配置初始化成该公寓的首个类型
              if (self.modeSelector('Dorm_Set').length > 0) {
              // 初始化宿舍配置为首个公寓首个宿舍类型的信息
                self.dormChooseForm.dormSet = self.modeSelector('Dorm_Set')[0].modeId
                // 根据所选宿舍类型加载宿舍类型信息
                self.setDormSet(self.dormChooseForm.dormSet)
              }
            }
          }
        }))
      } else {
        this.dormSetForm = {
          dormSet: '',
          price: '1000',
          dormStandard: '',
          roomSet: '',
          pubAreaSet: '',
          region: '',
          remark: ''
        }
        this.fourBedSum = '0'
        this.fourBedRmi = '0'
        this.sixBedSum = '0'
        this.sixBedRmi = '0'
        this.disabledBtn = true
      }
    },
    // 编辑窗体禁用 01 新增 02 修改
    getDisableEdit: function (propName, formName) {
      let disabled = false
      // 宿舍类型
      if (this.dormChooseForm.flatsName === '') {
        if (propName === 'dormSet' || propName === 'roomNo' || propName === 'bedNo') {
          disabled = true
        }
      } else {
        if (propName === 'dormSet') {
          disabled = false
        }
      }
      // 宿舍
      if (this.dormChooseForm.dormSet === '') {
        if (propName === 'roomNo' || propName === 'bedNo') {
          disabled = true
        }
      } else {
        if (propName === 'roomNo') {
          disabled = false
        }
      }
      // 床位
      if (this.dormChooseForm.roomNo === '') {
        if (propName === 'bedNo') {
          disabled = true
        }
      } else {
        disabled = false
      }
      return disabled
    },
    setVisible: function (showType) {
      console.log('进来啦。。。。。', showType)
      if (showType === '00') { // 宿舍显示
        this.chooseDormVisible = true
        this.chooseDormSelectedVisible = false
      }
      if (showType === '01') { // 宿舍已选信息展示
        this.chooseDormVisible = false
        this.chooseDormSelectedVisible = true
      }
    },
    // 切换dormSetForm的取值
    setDormSet: function (dormSet) {
      let listDorm = this.dormSetList.filter(item => item.flatsName + item.dormSet + item.dormStandard + item.direction === dormSet)
      if (listDorm.length > 0) {
        this.dormSetForm = listDorm[0]
        this.effectDrawing = this.global.staticUploadAddr + this.dormSetForm.effectDrawing
        this.bedDiagram = this.global.staticUploadAddr + this.dormSetForm.bedDiagram
        this.disabledBtn = false
      } else {
        this.dormSetForm = {}
        this.effectDrawing = ''
        this.bedDiagram = ''
        this.disabledBtn = true
        this.$alert('无可选宿舍')
      }
    },
    // 宿舍类型下拉框change
    handleDormSetChange: function (val) {
      if (val) {
        this.setDormSet(val)
        this.dormChooseForm.roomNo = ''
        this.dormChooseForm.bedNo = ''
      }
    },
    // 宿舍下拉框change
    handleFlatsChange: function () {
      let list = this.modeSelector('Dorm_Set')
      if (list.length > 0) {
        this.dormChooseForm.dormSet = list[0].modeId
        this.setDormSet(this.dormChooseForm.dormSet)
      }
      this.dormChooseForm.roomNo = ''
      this.dormChooseForm.bedNo = ''
    },
    // 床位下拉框change
    handleRoomChange: function () {
      this.dormChooseForm.bedNo = ''
    },
    clickImg: function (e) {
      this.showImg = true
        // 获取当前图片地址
      this.imgSrc = e.currentTarget.src
    },
    viewImg: function () {
      this.showImg = false
    },
    // 校验选择宿舍窗体
    validForm: function () {
      let valid = true
      let curTime = new Date().getTime()
      if ((curTime - this.waitTimeStart) > 1000 * 60 * 20) {
        this.$alert('超时操作，请重新登录')
        this.toHome()
        return false
      }
      if (this.dormChooseForm.dormSet === '') {
        this.$alert('请选择公寓等级！')
        return false
      }
      if (this.dormChooseForm.flasName === '') {
        this.$alert('请选择公寓楼！')
        return false
      }
      if (this.dormChooseForm.roomNo === '') {
        this.$alert('请选择宿舍！')
        return false
      }
      if (this.dormChooseForm.bedNo === '') {
        this.$alert('请选择床位！')
        return false
      }
      if (this.bedDiagram === '') {
        this.$alert('选择的床位出现异常！')
        return false
      }
      return valid
    },
    addBed: function () {
      var self = this
      this.chosenDorm = this.dormList.filter(item => item.flatsName === this.dormChooseForm.flatsName && item.roomNo === this.dormChooseForm.roomNo && item.bedNo === this.dormChooseForm.bedNo)[0]
      if (process.env.NODE_ENV === 'production') {
        if (this.validForm()) {
          self.axios.get('/college/processDormOldXF', {
            params: {
              bedId: self.chosenDorm.id,
              keyInfo: self.curStudent.studyNo
            }
          }).then(function (response) {
            if (response.data.result.success === true) {
              self.getViXFDormBed()
            } else {
              self.$alert('您选择的宿舍已被占用')
              self.toHome()
            }
          }, response => {
            self.$alert('您选择的宿舍已被占用')
            self.toHome()
          }).catch(function (response) {
            self.$alert('您选择的宿舍已被占用')
            self.toHome()
            console.log(response)
          })
        }
      }
    },
    toHome: function () {
      this.$router.push('/LoginDormOld')
      this.route = [{ path: '/LoginDormOld', component: require('./LoginDormOld.vue'), meta: { title: '宿舍登录' } }]
      this.$router.addRoutes(this.route)
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      let list = []
      switch (typeId) {
        case 'Dorm_Set':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.flatsName)
          break
        case 'Room':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.dormSet)
          break
        case 'Bed':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.roomNo && item.modeValue === this.dormChooseForm.flatsName)
          break
        default:
          list = this.modeSelectList.filter(function (element) {
            return element.typeId === typeId
          })
          break
      }
      return list
    }
  }
}
</script>
<style scoped>
  .content-icons{
    float:left;
    width:25%;
    height:35%;
    margin: 5px 0;
    text-decoration:none;
    color:#333;
  }
  .content-imgs{
    width: 19vw;
    height: 19vw;
  }
  .form-item {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    /* margin-bottom: 2px; */
    margin-left: 5px;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
    line-height: 40px !important;
  }
  .el-select {
    float: right;
    margin-right: 200px;
  }
  .deg-title{
    text-align: center !important;
    border-top: 1px solid #ffffff;
    background: #ffffff !important;
    line-height: 34px;
    margin-bottom: 16px;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 600;
    color: red;
  }
</style>


// WEBPACK FOOTER //
// DormOld.vue?6e87a9f9